<template>
    <a href="/mobile/home" class="top-icon" style="padding: 6px 8px!important">
        <HomeOutlined/>
    </a>
</template>

<script setup>
    import {HomeOutlined} from '@ant-design/icons-vue';
</script>

<style scoped>

</style>